import React from 'react';
import ReactDOM from 'react-dom';
import 'slick-carousel';
import Shop from '../react/Shop';
import startDropDownMenu from './common/dropdown';
import startCarouselEvents from './common/carouselEvents';
import CategoriesBox from '../react/shop/pages/CategoriesPage';
import AskInformations from '../react/shop/pages/AskInformationsPage';
import CartHeader from '../react/main-menu/CartHeader';
import MainMenu from '../react/main-menu/MainMenu';
import CarouselLogos from './common/CarouselLogos';
import SubCategoriesFooter from '../react/SubCategoriesFooter';
import ProductsSector from '../react/ProductsSector';
import SingleProductWoMatch from '../react/shop/pages/SingleProductWoMatch';
export default {
  init: function init() {
    startDropDownMenu(); // sector component

    document.querySelector('#product_list') && ReactDOM.render( /*#__PURE__*/React.createElement(ProductsSector, null), document.querySelector('#product_list'));
    document.querySelector('.product-root') && ReactDOM.render( /*#__PURE__*/React.createElement(SingleProductWoMatch, {
      slug: document.querySelector('#product-page').getAttribute('product-slug'),
      rootElement: ".product-root"
    }), document.querySelector('.product-root'));
    document.querySelector('.shop-root') && ReactDOM.render( /*#__PURE__*/React.createElement(Shop, null), document.querySelector('.shop-root'));
    document.querySelector('.logo-carousel') && ReactDOM.render( /*#__PURE__*/React.createElement(CarouselLogos, null), document.querySelector('.logo-carousel'));
    document.querySelector('.categories-box-container') && ReactDOM.render( /*#__PURE__*/React.createElement(CategoriesBox, {
      covidCategory: {
        title: document.querySelector('.categories-box-container').getAttribute('title-covid'),
        text: document.querySelector('.categories-box-container').getAttribute('text-covid'),
        link: document.querySelector('.categories-box-container').getAttribute('link-covid')
      }
    }), document.querySelector('.categories-box-container'));
    document.querySelector('#main-menu') && ReactDOM.render( /*#__PURE__*/React.createElement(MainMenu, null), document.querySelector('#main-menu'));
    document.querySelector('#CartHeader') && ReactDOM.render( /*#__PURE__*/React.createElement(CartHeader, null), document.querySelector('#CartHeader'));
    document.querySelector('#sub_categories') && ReactDOM.render( /*#__PURE__*/React.createElement(SubCategoriesFooter, null), document.querySelector('#sub_categories'));
    document.querySelector('#ask-information') && ReactDOM.render( /*#__PURE__*/React.createElement(AskInformations, null), document.querySelector('#ask-information'));
  },
  finalize: function finalize() {
    startCarouselEvents();
    $('.link_sector').on('click', function (e) {
      $('.link_sector').removeClass('active');
      $(this).addClass('active');
      var productsList = document.querySelector('.product_list');
      var newSlugs = e.currentTarget.getAttribute('products-sector');
      productsList.remove();
      var productsListNode = "<div class='product_list' id='product_list'></div>";
      document.querySelector('.products-recommandation').innerHTML += productsListNode;
      document.querySelector('.product_list').setAttribute('products-sector-show', newSlugs);
      ReactDOM.render( /*#__PURE__*/React.createElement(ProductsSector, null), document.querySelector('.product_list'));
    });

    if ($('#slider-temoignages')) {
      $('#slider-temoignages').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        }, {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      });
    }

    var first_rel = $('.resource').first().attr('rel');
    $('.mobile-none .resource').first().addClass('active_filter');
    $('.collapse').first().addClass('show');
    $('.mobile-none .resource_filter').hide();
    var resource = '.' + first_rel;
    $(resource).show();
    $('.resource').click(function () {
      $('.resource').removeClass('active_filter');
      jQuery(this).addClass('active_filter');
      var target = jQuery(this).attr('rel');
      $('.mobile-none .resource_filter').hide();
      $('.' + target).show();
    });
    $('.wpgmza_map').appendTo('.map').insertBefore('.footer');
    $('.wpgmza-store-locator').appendTo('.content_search');
    $('.wpgmza_marker_list_class').appendTo('.content_search');
    $('.wpgmza-directions-box').parent().appendTo('.directions-box');
  }
};